import { getFormattedValidationErrorFromAction } from 'Utils/getFormattedValidationErrorFromAction';

export const FETCH_MOBILE_OPERATOR = 'FETCH_MOBILE_OPERATOR';
export const FETCH_MOBILE_OPERATOR_FAIL = `${FETCH_MOBILE_OPERATOR}_FAIL`;
export const FETCH_MOBILE_OPERATOR_SUCCESS = `${FETCH_MOBILE_OPERATOR}_SUCCESS`;
export const SAVE_MOBILE_RECHARGE = 'SAVE_MOBILE_RECHARGE';
export const SAVE_MOBILE_RECHARGE_SUCCESS = `${SAVE_MOBILE_RECHARGE}_SUCCESS`;
export const SAVE_MOBILE_RECHARGE_FAIL = `${SAVE_MOBILE_RECHARGE}_FAIL`;
export const FETCH_AREACODES = 'FETCH_AREACODES';
export const FETCH_AREACODES_FAIL = `${FETCH_AREACODES}_FAIL`;
export const FETCH_AREACODES_SUCCESS = `${FETCH_AREACODES}_SUCCESS`;
export const FECTH_RECHARGEVALUE = 'FETCH_RECHARGEVALUE';
export const FECTH_RECHARGEVALUE_FAIL = `${FECTH_RECHARGEVALUE}_FAIL`;
export const FECTH_RECHARGEVALUE_SUCCESS = `${FECTH_RECHARGEVALUE}_SUCCESS`;

const initialStateDefault = {
  isLoading: false,
  filled: false,
  finishRequests: false,
  isError: false,
  error: null,
};
const initialStateMobileOperator = {
  value: [],
  ...initialStateDefault,
};
const initialStateAreaCodes = {
  value: [],
  ...initialStateDefault,
};
const initialStateRechargeValue = {
  value: [],
  ...initialStateDefault,
};

export const MobileOperatorReducer = (
  state = initialStateMobileOperator,
  action
) => {
  switch (action.type) {
    case FETCH_MOBILE_OPERATOR:
      return {
        ...state,
        isLoading: true,
        filled: false,
        finishRequests: false,
        isError: false,
      };
    case FETCH_MOBILE_OPERATOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        value: [...action.payload.data],
        filled: true,
        finishRequests: true,
        isError: false,
        status: (action?.payload?.data && Array.isArray(action?.payload?.data)) ? action?.payload?.data[0].status : action?.payload?.data.status,
        statusCode: action?.payload?.statusCode,
      };
    case FETCH_MOBILE_OPERATOR_FAIL:
      const errorData = getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        isLoading: false,
        value: [],
        error: errorData,
        filled: false,
        finishRequests: true,
        isError: true,
        statusCode: action?.payload?.statusCode,
        status: (action?.payload?.data && Array.isArray(action?.payload?.data)) ? action?.payload?.data[0].status : action?.payload?.data?.status,
      };
    case SAVE_MOBILE_RECHARGE:
      return {
        ...state,
        isSave: true,
        saveSuccessfully: false,
      };
    case SAVE_MOBILE_RECHARGE_SUCCESS:
      return {
        ...state,
        isSave: false,
        saveSuccessfully: true,
        idRecharge: action.payload?.id,
        isError: false,
        status: action.payload?.status,
        statusCode: action.payload?.statusCode,
        error: null,
      };
    case SAVE_MOBILE_RECHARGE_FAIL:
      return {
        ...state,
        isSave: false,
        saveSuccessfully: false,
        isError: true,
        status: action.payload?.data?.status,
        error: action.payload,
        statusCode: action.payload?.statusCode,
      };

    default:
      return state || initialStateMobileOperator;
  }
};

export const AreaCodesReducer = (state = initialStateAreaCodes, action) => {
  switch (action.type) {
    case FETCH_AREACODES:
      return {
        ...state,
        isLoading: true,
        filled: false,
        finishRequests: false,
        isError: false,
      };
    case FETCH_AREACODES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        value: [...action.payload.data],
        filled: true,
        finishRequests: true,
        isError: false,
      };
    case FETCH_AREACODES_FAIL:
      const errorDataAreaCodes = getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        isLoading: false,
        value: [],
        error: errorDataAreaCodes,
        filled: false,
        finishRequests: true,
        isError: true,
      };
    default:
      return state || initialStateAreaCodes;
  }
};

export const RechargeValuesReducer = (
  state = initialStateRechargeValue,
  action
) => {
  switch (action.type) {
    case FECTH_RECHARGEVALUE:
      return {
        ...state,
        isLoading: true,
        filled: false,
        finishRequests: false,
        isError: false,
      };
    case FECTH_RECHARGEVALUE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        value: [...action.payload.data],
        filled: true,
        finishRequests: true,
        isError: false,
        statusCode: action.payload.statusCode
      };
    case FECTH_RECHARGEVALUE_FAIL:
      const errorData = getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        isLoading: false,
        value: [],
        error: errorData,
        filled: false,
        finishRequests: true,
        isError: true,
        statusCode: action.payload.statusCode
      };
    default:
      return state || initialStateRechargeValue;
  }
};
